import { QueryObserverOptions, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getChemicalProductQuery } from './api';
import { ChemicalProductDTO } from '@behavior/inventories/dto/ChemicalProductDTO';

type UseQueryOptionsKeys = Pick<QueryObserverOptions<ChemicalProductDTO>, 'enabled'>;

export default function useGetChemicalProductQuery(
  chemicalId: number,
  options?: UseQueryOptionsKeys
) {
  const { t } = useTranslation();
  const data = useQuery(
    ['getChemicalProductQuery', chemicalId],
    () => getChemicalProductQuery(chemicalId),
    {
      onError: error => {
        toast.error(t('message.title.error.get.chemical.product'));
      },
      ...options,
    }
  );

  return data;
}
